export class InvoicesRepository {
    driver;
    context;
    constructor(driver, context) {
        this.driver = driver;
        this.context = context;
    }
    async getInvoice(id) {
        const rows = await this.driver.query({ sql: 'SELECT * FROM invoices WHERE id = ?', params: [id] });
        const invoice = rows[0];
        if (!invoice)
            return null;
        const lines = await this.driver.query({
            sql: 'SELECT * FROM invoice_lines WHERE invoice_id = ? ORDER BY rowid',
            params: [id],
        });
        return { ...mapInvoice(invoice), lines: lines.map(mapLine) };
    }
    async findByNumber(number) {
        const rows = await this.driver.query({
            sql: 'SELECT id FROM invoices WHERE number = ?',
            params: [number],
        });
        return rows[0] ? this.getInvoice(String(rows[0].id)) : null;
    }
    async listInvoices(options = {}) {
        const { limit = 100, sinceIso } = options;
        const rows = sinceIso
            ? await this.driver.query({
                sql: 'SELECT * FROM invoices WHERE issued_at >= ? ORDER BY issued_at DESC LIMIT ?',
                params: [sinceIso, limit],
            })
            : await this.driver.query({
                sql: 'SELECT * FROM invoices ORDER BY issued_at DESC LIMIT ?',
                params: [limit],
            });
        return rows.map(mapInvoice);
    }
    /** Reprint retention (local-dataset.md): prune synced invoices older than the window. */
    async pruneSynced(olderThanIso) {
        const result = await this.driver.execute({
            sql: `DELETE FROM invoices WHERE sync_state = 'SYNCED' AND issued_at < ?`,
            params: [olderThanIso],
        });
        return result.changes;
    }
}
function mapInvoice(r) {
    return {
        id: String(r.id),
        propertyId: String(r.property_id),
        number: String(r.number),
        kind: String(r.kind),
        status: String(r.status),
        orderId: r.order_id == null ? null : String(r.order_id),
        guestName: String(r.guest_name),
        guestGstin: r.guest_gstin == null ? null : String(r.guest_gstin),
        placeOfSupply: String(r.place_of_supply),
        isInterState: Number(r.is_inter_state) === 1,
        subtotalPaise: Number(r.subtotal_paise),
        discountPaise: Number(r.discount_paise),
        cgstPaise: Number(r.cgst_paise),
        sgstPaise: Number(r.sgst_paise),
        igstPaise: Number(r.igst_paise),
        roundOffPaise: Number(r.round_off_paise),
        totalPaise: Number(r.total_paise),
        mode: String(r.mode),
        voidReason: r.void_reason == null ? null : String(r.void_reason),
        issuedByUserId: String(r.issued_by_user_id),
        issuedAt: String(r.issued_at),
        syncState: String(r.sync_state),
        offersJson: r.offers_json == null ? null : String(r.offers_json),
    };
}
function mapLine(r) {
    return {
        id: String(r.id),
        invoiceId: String(r.invoice_id),
        description: String(r.description),
        hsn: String(r.hsn),
        quantityMilli: Number(r.quantity_milli),
        unitPricePaise: Number(r.unit_price_paise),
        gstRateBp: Number(r.gst_rate_bp),
        discountPaise: Number(r.discount_paise),
        taxablePaise: Number(r.taxable_paise),
        cgstPaise: Number(r.cgst_paise),
        sgstPaise: Number(r.sgst_paise),
        igstPaise: Number(r.igst_paise),
        totalPaise: Number(r.total_paise),
    };
}
//# sourceMappingURL=invoices.js.map